import { assert_array_not_empty } from '@shared/asserts/utils_asserts';
import { CONSTANTS__shared } from '@shared/constants/CONSTANTS__shared';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION__base } from '../../_invocations/_base/INVOCATION__base';

//todo: rerite this logic after decide behaviour on product area
export function FN_GRAPH__layout_move_ovelap_nodes_to_first_free_position(graph: DTO_GRAPH__instance) {
  // Oldest first → they are already placed, newer nodes move around them
  const nodes = Array.from(graph.nodes__get_all().values()).sort(INVOCATION__base.sort_by_added_at);

  if (nodes.length <= 1) return;

  const cell_size = CONSTANTS__shared.GRID_CELL_SIZE;

  // "settled" tracks final positions of already-processed nodes
  const settled: INVOCATION__base[] = [];

  for (const node of nodes) {
    if (!has_overlap(node, settled)) {
      // No collision with any already-settled node — keep position as-is
      settled.push(node);
      continue;
    }

    // Collision: search leftward, then fallback vertically at each x column
    let placed = false;

    let node_with_lowest_position = get_node_with_lowest_position(settled);

    let [x_start, y_start] = [node_with_lowest_position.meta.graph_x_px, node_with_lowest_position.meta.graph_y_px];

    for (let col = 1; col < 500 && !placed; col++) {
      const x = x_start - col * cell_size;
      const oy = y_start;

      // Try same Y first
      if (!would_collide(node, settled, x, oy)) {
        node.meta.graph_x_px = x;
        node.meta.graph_y_px = oy;
        placed = true;
        break;
      }
    }

    settled.push(node);
  }
}

function get_node_with_lowest_position(nodes: INVOCATION__base[]): INVOCATION__base {
  assert_array_not_empty(nodes);
  if (nodes.length === 1) return nodes[0];

  let out = nodes[0];

  for (let node of nodes) {
    if (node.meta.graph_x_px + node.meta.graph_y_px < out.meta.graph_x_px + out.meta.graph_y_px) {
      out = node;
    }
  }

  return out;
}

function would_collide(node: INVOCATION__base, nodes: INVOCATION__base[], x: number, y: number): boolean {
  const ox = node.meta.graph_x_px;
  const oy = node.meta.graph_y_px;

  node.meta.graph_x_px = x;
  node.meta.graph_y_px = y;

  const collision = has_overlap(node, nodes, node.meta.node_id);

  node.meta.graph_x_px = ox;
  node.meta.graph_y_px = oy;

  return collision;
}

function has_overlap(target: INVOCATION__base, nodes: INVOCATION__base[], ignore_node_id?: string): boolean {
  for (const other of nodes) {
    if (other.meta.node_id === ignore_node_id) continue;

    if (target.meta.is_intersects_with(other.meta)) {
      return true;
    }
  }
  return false;
}
